import classNames from 'classnames'
import { Button, EnumHelperText, HelperText } from 'shared/ui'
import { makeTextFieldAutoFocus, makeTextFieldIcon, TextField } from 'shared/ui/TextField'
import styles from './styles.module.scss'

type KnowledgeBaseActionsUrlInputProps = {
  placeholder: string
  submitLabel: string
  value: string
  isUploading: boolean
  error: string
  onChange: (value: string) => void
  onSubmit: () => void
  onCancel: () => void
}

export const KnowledgeBaseActionsUrlInput = ({
  placeholder,
  submitLabel,
  value,
  isUploading,
  error,
  onChange,
  onSubmit,
  onCancel,
}: KnowledgeBaseActionsUrlInputProps) => {
  return (
    <div className={styles.uploadViaUrlContainer}>
      <TextField
        size='extraSmall'
        variant='outline'
        value={value}
        onChange={onChange}
        InputProps={{ placeholder }}
        disabled={isUploading}
        leftActions={[
          makeTextFieldIcon({
            icon: 'globe',
            color: 'var(--content-primary-tertiary)',
            fontSize: 16,
            margin: '0 0 0 8px',
          }),
        ]}
        rightActions={[
          () => (
            <Button
              typeBtn='text'
              size='small'
              text='Cancel'
              disabled={isUploading}
              onClick={onCancel}
            />
          ),
          () => (
            <Button
              size='small'
              text={submitLabel}
              disabled={!value || isUploading}
              onClick={onSubmit}
            />
          ),
        ]}
        mainActions={[makeTextFieldAutoFocus({ withFocus: true })]}
        className={classNames(styles.textInput, styles.uploadViaUrl)}
        error={error}
      />
      {error && (
        <HelperText
          paddingBlock={'3.5px'}
          icon={'alertTriangleSmall'}
          variant={EnumHelperText.Error}
          text={error}
        />
      )}
    </div>
  )
}
